import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "@/components/controls/MultiSelect";
import { ControlProps } from "../types";

export const MultiSelectControl: React.FC<ControlProps> = ({
  value,
  onChange,
  name,
  options,
  multiSelect
}) => {
  const { t } = useTranslation();
  const multiOptions = useMemo(
    () =>
      (options ?? []).flatMap(({ id, displayName, name: optionName }) =>
        id === null
          ? []
          : [
              {
                value: String(id),
                label: displayName ?? optionName ?? String(id)
              }
            ]
      ),
    [options]
  );

  return (
    <MultiSelect
      options={multiOptions}
      selectedValues={
        Array.isArray(value)
          ? value.flatMap((item) =>
              typeof item === "string"
                ? [item]
                : typeof item === "number"
                  ? [String(item)]
                  : []
            )
          : []
      }
      onValueChange={onChange}
      placeholder={t("select")}
      matchTriggerWidth
      formatter={(optionValue) =>
        multiOptions.find((option) => option.value === optionValue)?.label ??
        optionValue
      }
      showSearch={multiSelect?.showSearch}
      onSearch={multiSelect?.onSearch}
      searchPlaceholder={multiSelect?.searchPlaceholder}
      popOverFooter={multiSelect?.popOverFooter}
      maxCount={multiSelect?.maxCount}
      data-test={`${name}-multiselect`}
    />
  );
};
